import PropTypes from 'prop-types';

import { Box, Tabs, Tab, Typography, Grid } from '@mui/material';

import DescriptionIcon from '@mui/icons-material/Description';
import SpeedIcon from '@mui/icons-material/Speed';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

import DashboardBarChart from './Barchart';
import RandomnessDonutChart from './Doughnutchart';
import TokenUsageAndCostChart from './TokenUsageAndCostChart';
import UserUsageTable from './UserUsageTable';

function CustomTabPanel(props) {
  const { children, value, currentTab, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== currentTab}
      id={`dashboard-tabpanel-${currentTab}`}
      aria-labelledby={`dashboard-tab-${currentTab}`}
      {...other}
    >
      {value === currentTab && (
        <Box sx={{ pt: 3, mb: 2 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const tabData = [
  {
    name: 'Proposals',
    icon: <DescriptionIcon fontSize="small" />,
    description: 'Browse, search, and manage generated proposals.',
  },
  {
    name: 'Latency',
    icon: <SpeedIcon fontSize="small" />,
    description: 'Track generation speeds and API response times.',
  },
  {
    name: 'Cost & Usage',
    icon: <AttachMoneyIcon fontSize="small" />,
    description: 'Monitor token spend, costs, and budget health.',
  },
];

const tableHeading = [
  'SL No', 'Name', 'Input Tokens', 'Output Tokens',
  'Proposals Generated', 'Cost ($)',
];

const DashboardTabs = ({ activeTab, setActiveTab, data }) => {
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ width: '100%', mt: 3 }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={activeTab}
          onChange={handleChange}
          aria-label="Dashboard views"
          indicatorColor="primary"
          textColor="primary"
        >
          {tabData.map((tab, index) => (
            <Tab
              key={tab.name}
              icon={tab.icon}
              iconPosition="start"
              label={tab.name}
              value={tab.name}
              id={`dashboard-tab-${index}`}
              aria-controls={`dashboard-tabpanel-${index}`}
              sx={{ textTransform: 'none', fontWeight: 600 }}
            />
          ))}
        </Tabs>
      </Box>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mt: 1.5, mb: 1 }}
      >
        {tabData.find(obj => obj.name === activeTab)?.description}
      </Typography>

      <CustomTabPanel value='Proposals' currentTab={activeTab}>
        <Grid container spacing={2} alignItems="stretch">
          <Grid size={{ xs: 12, md: 4 }} sx={{ display: 'flex' }}>
            <RandomnessDonutChart
              data={data?.proposalData?.randomness_list}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 8 }} sx={{ display: 'flex' }}>
            <DashboardBarChart
              metricType="proposals"
              title={`Average Score Across ${data?.proposalData?.total_proposals} Proposals`}
              barchartData={
                data?.proposalData?.avg_score_list ?
                  data?.proposalData?.avg_score_list : []
              }
            />
          </Grid>
        </Grid>
      </CustomTabPanel>

      <CustomTabPanel value='Latency' currentTab={activeTab}>
        <Grid size={{ xs: 12, md: 8 }} sx={{ display: 'flex' }}>
          <DashboardBarChart
            metricType="latency"
            title={`Average Latency (Seconds)`}
            barchartData={
              data?.latencyData?.avg_latency_list ?
                data?.latencyData?.avg_latency_list : []
            }
          />
        </Grid>
      </CustomTabPanel>

      <CustomTabPanel value='Cost & Usage' currentTab={activeTab}>
        <Grid size={{ xs: 12, md: 8 }} sx={{ display: 'flex' }}>
          <TokenUsageAndCostChart
            data={
              data?.costData?.module_usage_list ?
                data?.costData?.module_usage_list : []
            }
          />
        </Grid>

        <Grid size={{ xs: 12 }} mt={2}>
          <UserUsageTable
            heading={tableHeading}
            rows={
              data?.costData?.user_usage_list ?
                data?.costData?.user_usage_list : []
            }
          />
        </Grid>
      </CustomTabPanel>
    </Box>
  );
};

DashboardTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};

export default DashboardTabs;